module.exports = __webpack_public_path__ + "img/BKT-banner-getpica.2e2a99c0.png";